/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetRiderLocations200ResponseInner,
} from '../models/index';
import {
    GetRiderLocations200ResponseInnerFromJSON,
    GetRiderLocations200ResponseInnerToJSON,
} from '../models/index';

/**
 * 
 */
export class LocationsApi extends runtime.BaseAPI {

    /**
     */
    async getRiderLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRiderLocations200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRiderLocations200ResponseInnerFromJSON));
    }

    /**
     */
    async getRiderLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRiderLocations200ResponseInner>> {
        const response = await this.getRiderLocationsRaw(initOverrides);
        return await response.value();
    }

}
